import { NgModule } from '@angular/core';
import { PaginationComponent } from './pagination.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [PaginationComponent],
  imports: [SharedModule],
  exports: [PaginationComponent]
})
export class PaginationModule { }
